import React, { Component } from 'react'
import Tooltip from '@material-ui/core/Tooltip'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Cancel from '@material-ui/icons/Cancel'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Typography from '@material-ui/core/Typography'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core//Paper'
import UserInput from './UserInput.jsx'

const acisLogo = "url(img/PoweredbyACIS.gif)"

const styles = {
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: "0.5em",
  },
  toolbar: {
    height: "3em",
    minHeight: "3em",
  },
  logolink: {
    backgroundImage: acisLogo,
    width: "113px",
    height: "37px",
  },
  drawer: {
    transform: "translate(0px, 3em)",
    maxWidth: "1024px",
  },
  cancel: {
    position: "absolute",
    right: "32px",
  },
}

class NavDrawer extends Component { 
  constructor (props) {
    super(props)
    this.state = {
      drawerOpen: true
    }
  }

  startRequest = (params) => {
    this.props.startRequest(params)
    this.handleCloseDrawer()
  }

  handleCloseDrawer = () => {
    this.setState({drawerOpen: false})
    this.props.showResults(true)
  }

  handleMenuClick = () => {
    if (this.state.drawerOpen) {
      this.handleCloseDrawer()
    } else {
      this.setState({drawerOpen: true})
      this.props.showResults(false)
    }
  }

  render() {
    const { classes } = this.props 
    return (
      <div>
        <AppBar color="primary" position="static">
          <Toolbar className={classes.toolbar}>
            <IconButton className={classes.menuButton} color="inherit" title="Windrose settings" onClick={this.handleMenuClick} >
              <MenuIcon />
            </IconButton>
            <Typography 
              variant="h1" 
              color="inherit" 
              className={classes.grow}
            >
              ACIS Wind Roses
            </Typography>
            <a href="https://www.rcc-acis.org" className={classes.logolink} target="_blank" />
          </Toolbar>
        </AppBar>

        {this.state.drawerOpen &&
          <Paper>
            <Tooltip title="Close">
              <Cancel className={classes.cancel} color="primary" onClick={this.handleCloseDrawer} />
            </Tooltip>
            <UserInput 
              startRequest={this.startRequest}
              userParams={this.props.userParams}
            />
          </Paper>
        }
       </div>
    )
  }
}

export default withStyles(styles)(NavDrawer)



// WEBPACK FOOTER //
// ./src/NavDrawer.jsx